<template>
    <div v-if="data" class="inner" v-html="compiledMarkdown"></div>
</template>

<script>

import marked from 'marked';
import DOMPurify  from 'dompurify';

export default {

    name: 'MarkdownComponent',
    props: {
        data: {
            type: String,
            default: ''
        },
    },
    computed: {
        compiledMarkdown: function () {
            const d = DOMPurify.sanitize(marked(this.data));
            this.$emit('changed');
            return d;
        },
    },
    methods: {},
};
</script>
